const CONTEXT_TOKEN_WARNING_THRESHOLD = 200_000;

function sessionKeyFromSession(session: any): string | null {
  if (typeof session?.sessionKey === 'string') return session.sessionKey;
  if (typeof session?.key === 'string') return session.key;
  if (typeof session?.id === 'string') return session.id;
  return null;
}

export function getSessionTokenCount(sessions: any[], sessionKey: string | null | undefined): number | null {
  if (!sessionKey) {
    return null;
  }

  const session = sessions.find((candidate) => sessionKeyFromSession(candidate) === sessionKey);
  const totalTokens = session?.totalTokens;
  return typeof totalTokens === 'number' && Number.isFinite(totalTokens) ? totalTokens : null;
}

export function shouldBypassContextTokenWarning(messageText: string): boolean {
  const normalized = messageText.trim().toLowerCase();
  return normalized.startsWith('/');
}

export function shouldShowContextTokenWarning({
  messageText: _messageText,
  hasAttachments: _hasAttachments,
  tokenCount: _tokenCount,
}: {
  messageText: string;
  hasAttachments: boolean;
  tokenCount: number | null;
}): boolean {
  return false;
}

export function formatTokenCountForWarning(tokenCount: number): string {
  return new Intl.NumberFormat('en-US').format(tokenCount);
}

export { CONTEXT_TOKEN_WARNING_THRESHOLD };
